(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/animated-backgrounds/feather-background.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/animated-backgrounds/feather-background.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useRef = _React.useRef,
  useEffect = _React.useEffect;
const FeatherWorld = function (color, size, canvas) {
  this.gravity = [0.3, 2];
  this.size = size;
  this.update = () => {
    this.size = [canvas.width, canvas.height];
  };
  this.featherImages = ["feather-".concat(color, "-11.png"), "feather-".concat(color, "-12.png"), "feather-".concat(color, "-13.png"), "feather-".concat(color, "-14.png")].map(file => {
    const image = new Image();
    image.src = "".concat(svs.core.config.data.svsconfig.cdn, "/images/tickets/easter-feathers/").concat(file);
    return image;
  });
  this.imageScale = 1 / 3;
  this.margin = 50;
};
const featherDrawObj = world => {
  const size = world.size;
  const position = [Math.floor(Math.random() * size[0]), Math.random() * size[1]];
  const seed = Math.random() * (Math.PI * 2);
  const scale = Math.random() * 0.4 + 0.7;
  const realLifeScale = 0.01 * scale * 5;
  const mass = [0, 0.2 * scale];
  const imageId = Math.floor(Math.random() * world.featherImages.length);
  return {
    seed,
    position,
    mass,
    update: (obj, world, delta) => {
      const gravity = world.gravity,
        size = world.size,
        margin = world.margin;
      const xOrigin = position[0];
      const xOscillation = Math.sin(seed + delta / 1500 * scale) * 30 * scale;
      const yOscillation = Math.sin(seed + delta / 1500 * 2 * scale) * 10 * scale;
      const newPos = seed + delta * gravity[0] * realLifeScale;
      const x = xOrigin + xOscillation + newPos;
      const relativeX = x < -margin ? size[0] + margin * 2.5 - Math.abs(x) % size[0] : x % (size[0] + margin) - margin / 2;
      let y = (position[1] + delta * gravity[1] * mass[1] * realLifeScale) % size[1];
      y += -yOscillation;
      if (y > size[1]) {
        y -= size[1];
      }
      obj.position = [relativeX, y];
      obj.rotation = -xOscillation;
    },
    draw: (obj, ctx) => {
      const featherImages = world.featherImages,
        imageScale = world.imageScale;
      const position = obj.position,
        rotation = obj.rotation;
      const _position = _slicedToArray(position, 2),
        x = _position[0],
        y = _position[1];
      const image = featherImages[imageId];
      if (!image) {
        return;
      }
      ctx.save();
      ctx.setTransform(imageScale * scale, 0, 0, imageScale * scale, x, y);
      ctx.rotate(rotation * Math.PI / 180);
      ctx.drawImage(image, -image.width / 2, -image.width / 2);
      ctx.restore();
    }
  };
};
setGlobal('svs.tickets.play.components.animatedBackgrounds.FeatherBackground', color => () => {
  const containerRef = useRef();
  const canvasRef = useRef();
  useEffect(() => {
    const world = new FeatherWorld(color, [window.innerWidth, window.innerHeight], canvasRef.current);
    const _svs$tickets$play$uti = svs.tickets.play.utils.particleRenderer({
        drawObject: featherDrawObj,
        world,
        canvas: canvasRef.current,
        particlePerPixel: 0.00004
      }),
      destroy = _svs$tickets$play$uti.destroy;
    const onResize = _.debounce(() => {
      if (canvasRef.current) {
        canvasRef.current.height = window.innerHeight;
        canvasRef.current.width = window.innerWidth;
      }
    }, 500);
    addEventListener('resize', onResize);
    return () => {
      removeEventListener('resize', onResize);
      destroy();
    };
  }, []);
  return React.createElement("div", {
    className: "animated-background-container",
    ref: containerRef
  }, React.createElement("canvas", {
    height: window.innerHeight,
    ref: canvasRef,
    width: window.innerWidth
  }));
});

 })(window);